export const nav = {
  services: 'Tjenester',
  analyse: 'Analyse',
  booking: 'Booking',
  pricing: 'Priser',
  contact: 'Kontakt'
};

export const hero = {
  title1: 'Nettsider, Apper',
  title2: 'og IT-løsninger for din bedrift',
  subtitle: 'Vi hjelper deg fra idé til lansering – nettsider, mobilapper, webapplikasjoner og IT-hjelp, levert med kvalitet og pålitelighet.',
  feature1: 'Sterk kompetanse innen webutvikling, apputvikling og IT-support for resultatdrevne løsninger.',
  feature2: 'Fra idé og konseptutvikling til design, programmering og lansering – vi gjør prosessen smidig.',
  btnBooking: 'Booking',
  btnContact: 'Kontakt Oss'
};

export const whyChoose = {
  title: 'Hvorfor Velge Oss som Din Partner?',
  quality: 'Høy kvalitet',
  qualityDesc: 'Dedikert til å levere høykvalitetsløsninger – enten det er nettsider, apper eller IT-support – som møter eller overgår dine forventninger, alltid i tide.',
  communication: 'Tydelig Kommunikasjon',
  communicationDesc: 'Tett dialog gjennom hele prosessen med raske svar og forståelige forklaringer uten teknisk sjargong.',
  solutions: 'Skreddersydde Løsninger',
  solutionsDesc: 'Hvert prosjekt er unikt. Vi lager tilpassede nettsider, apper og IT-løsninger basert på dine spesifikke behov og forretningsmål.'
};

export const services = {
  title: 'Tjenester Vi Tilbyr',
  service1Title: 'Nettside Utvikling',
  service1Desc: 'Responsive og attraktive nettsider for din bedrift. Skreddersydde design som konverterer besøkende til kunder.',
  service2Title: 'App- og Webapplikasjonsutvikling',
  service2Desc: 'Vi utvikler mobilapper og webapplikasjoner tilpasset dine behov – fra enkle verktøy til komplekse systemer for iOS, Android og nettleser.',
  service3Title: 'IT-hjelp & Support',
  service3Desc: 'Praktisk IT-hjelp for bedrifter – feilsøking, oppsett av systemer, brukerstøtte og teknisk rådgivning. Vi er tilgjengelige når du trenger oss.',
  service4Title: 'SEO Optimalisering',
  service4Desc: 'Øk synlighet og organisk trafikk på Google. Vi optimaliserer nettstedet ditt for å rangere høyere i søkeresultatene.',
  service5Title: 'Vedlikehold & Drift',
  service5Desc: 'Oppdateringer, sikkerhet og teknisk support for nettsider og applikasjoner. Vi holder løsningene dine i gang 24/7.',
  seeDetails: 'Se detaljer',
  btnAll: 'Se Alle Tjenester'
};

export const process = {
  title: 'Veien til Din Nye Løsning',
  subtitle: 'Enkel og grei prosess fra start til slutt – enten det er nettside, app eller IT-prosjekt',
  step1: 'Innledende Samtale',
  step1Desc: 'Vi blir kjent og diskuterer dine behov, mål og visjon for prosjektet.',
  step2: 'Planlegging & Design',
  step2Desc: 'Du mottar designforslag og teknisk plan basert på dine preferanser og krav.',
  step3: 'Utvikling',
  step3Desc: 'Vårt team bygger løsningen din med ren kode, god arkitektur og SEO-optimalisering.',
  step4: 'Gjennomgang & Tilbakemelding',
  step4Desc: 'Du gjennomgår første versjon og gir tilbakemelding for justeringer.',
  step5: 'Kvalitetssikring',
  step5Desc: 'Endelig testing på alle enheter og nettlesere for å sikre perfeksjon.',
  step6: 'Lansering & Support',
  step6Desc: 'Løsningen din går live med løpende support, vedlikehold og IT-hjelp.'
};

export const features = {
  title: 'Alt Inkludert',
  feature1: 'Ferdig Nettside',
  feature2: 'Hosting',
  feature3: 'SEO Optimalisert',
  feature4: 'Moderne Design',
  feature5: 'Mobilvennlig',
  feature6: 'SSL Sikkerhet',
  feature7: 'App-utvikling',
  feature8: 'IT-hjelp & Support'
};

export const pricing = {
  title: 'Priser',
  subtitle: 'Velg pakken som passer dine behov',
  basis: 'Basis',
  standard: 'Standard',
  premium: 'Premium',
  perMonth: '/ mnd',
  setupFee: '+ {{amount}} etableringsgebyr',
  mostPopular: 'Mest Populær',
  btnStart: 'Kom i Gang',
  basisDesc: 'Perfekt for små bedrifter som starter opp.',
  standardDesc: 'Mest populære valg for voksende bedrifter.',
  premiumDesc: 'For bedrifter som trenger den komplette løsningen.',
  feature1: 'Opptil {{pages}} sider',
  feature2: 'Responsivt design',
  feature3: '{{updates}} årlige oppdateringer',
  feature4Basis: 'SEO optimalisering',
  feature4Standard: 'Avansert SEO',
  feature4Premium: 'Premium SEO & Analytics',
  feature5: 'SSL sertifikat',
  feature6Basis: 'Grunnleggende support',
  feature6Standard: 'Prioritert support',
  feature6Premium: 'Dedikert support 24/7',
  feature7Premium: 'Avanserte funksjoner',
  disclaimer: 'Alle priser inkluderer MVA. 12 måneders binding med 30 dagers oppsigelsestid etter. App- og IT-prosjekter prises separat etter behov.'
};

export const cta = {
  title: 'Klar til å Starte Ditt Neste Prosjekt?',
  subtitle: 'Enten du trenger en nettside, en app eller IT-hjelp – la oss skape en digital løsning som gir resultater for din bedrift.',
  btn: 'Book en Konsultasjon'
};

export const faq = {
  title: 'Ofte Stilte Spørsmål',
  q1: 'Hvor lang tid tar det å bygge en nettside?',
  a1: 'Vanligvis 5 - 10 dager fra prosjektstart til lansering, avhengig av kompleksitet og omfang. Vi kan tilpasse raskere tidslinjer ved behov.',
  q2: 'Hva er inkludert i månedsprisen?',
  a2: 'Hosting, SSL-sertifikat, sikkerhetsoppdateringer, backup, teknisk support og et antall innholdsoppdateringer per år basert på pakken din.',
  q3: 'Hjelper dere med domeneregistrering?',
  a3: 'Domene kjøpes separat da prisene varierer. Vi kan veilede deg gjennom prosessen eller håndtere det for deg.',
  q4: 'Hva skjer etter at nettsiden er lansert?',
  a4: 'Vi tilbyr løpende support og vedlikehold. Du kan kontakte oss når som helst for hjelp, og vi sørger for at nettstedet ditt forblir sikkert og oppdatert.'
};

export const support = {
  title: 'Vi Er Her for å Hjelpe',
  subtitle: 'Flere måter å komme i kontakt med oss på',
  email: {
    title: 'E-post Support',
    description: 'Send oss en e-post når som helst, vi svarer innen 24 timer',
    action: 'Send E-post',
  },
  phone: {
    title: 'Telefon Support',
    description: 'Ring oss for umiddelbar hjelp med nettside, app eller IT-spørsmål',
    action: 'Ring Nå',
  },
  ai: {
    title: 'AI Assistent',
    description: 'Få øyeblikkelige svar på dine spørsmål 24/7',
    action: 'Chat Nå',
  },
};

export const contactForm = {
  title: 'Kontakt Oss',
  subtitle: 'Fyll ut skjemaet nedenfor, så tar vi kontakt med deg så snart som mulig.',
  firstName: 'Navn',
  lastName: 'Etternavn',
  email: 'E-post',
  phone: 'Telefonnummer',
  business: 'Virksomhet',
  message: 'Melding',
  maxChars: 'Maksimalt 500 tegn',
  btnSubmit: 'Send Melding',
  btnSending: 'Sender...',
  placeholderFirstName: 'Ditt fornavn',
  placeholderLastName: 'Ditt etternavn',
  placeholderEmail: 'din@epost.no',
  placeholderPhone: '+47 123 45 678',
  placeholderBusiness: 'Ditt firmanavn',
  placeholderMessage: 'Fortell oss om ditt prosjekt – nettside, app, IT-hjelp eller noe annet...',
  successMessage: 'Takk for din henvendelse! Vi tar kontakt med deg snart.',
  errorMessage: 'Noe gikk galt. Vennligst prøv igjen.',
  validationError: 'Vennligst fyll ut alle feltene',
  emailError: 'Vennligst oppgi en gyldig e-postadresse',
  lengthError: 'Meldingen kan ikke overstige 500 tegn'
};

export const footer = {
  description: 'Norsk IT-selskap med fokus på webutvikling, apputvikling og IT-hjelp. Fra idé til lansering med kvalitet og pålitelighet.',
  servicesTitle: 'Tjenester',
  service1: 'Nettside Utvikling',
  service2: 'App-utvikling',
  service3: 'IT-hjelp & Support',
  service4: 'SEO Optimalisering',
  companyTitle: 'Selskap',
  aboutUs: 'Om Oss',
  projects: 'Våre Prosjekter',
  contact: 'Kontakt',
  contactTitle: 'Kontakt',
  copyright: '© 2025 NorWeb AS. Alle rettigheter reservert.'
};

export const booking = {
  title: 'Book en Konsultasjon',
  subtitle: 'Velg et tidspunkt som passer deg, så tar vi en uforpliktende prat om ditt prosjekt – enten det gjelder nettside, app eller IT-hjelp.',
  backHome: 'Tilbake til Hjem',
  duration: '15 Minutter',
  durationDesc: 'Vi tar oss god tid til å forstå dine behov og mål.',
  format: 'Video eller Telefon',
  formatDesc: 'Velg det formatet som passer deg best.',
  preparation: 'Ingen Forberedelse',
  preparationDesc: 'Kom som du er - vi guider deg gjennom samtalen.'
};

export const chatbot = {
  title: 'AI Assistent',
  subtitle: 'Online nå',
  openChat: 'Åpne chat',
  closeChat: 'Lukk chat',
  inputPlaceholder: 'Skriv din melding...',
  sendMessage: 'Send melding',
  welcomeMessage: 'Hei! 👋 Jeg er din AI-assistent. Jeg kan svare på spørsmål om våre tjenester innen webutvikling, apputvikling og IT-hjelp, samt priser, prosess og mer. Hvordan kan jeg hjelpe deg i dag?',
  answerPricing: 'Vi tilbyr tre pakker for nettsider:\n\n📦 Basis: Kr 990/mnd + 4 490 etablering\n- Opptil 5 sider\n- 2 årlige oppdateringer\n- SEO optimalisering\n- Grunnleggende support\n\n📦 Standard: Kr 1 490/mnd + 4 490 etablering (Mest populær)\n- Opptil 10 sider\n- 4 årlige oppdateringer\n- Avansert SEO\n- Prioritert support\n\n📦 Premium: Kr 2 490/mnd + 4 490 etablering\n- Opptil 20 sider\n- 12 årlige oppdateringer\n- Full SEO-pakke\n- Dedikert support\n- Skreddersydd design\n\nApp-utvikling og IT-hjelp prises separat etter behov. Ta kontakt for et uforpliktende tilbud!\n\nAlle priser inkluderer hosting, SSL og MVA.',
  answerServices: 'Vi tilbyr følgende tjenester:\n\n🌐 Nettside Utvikling - Responsive og attraktive nettsider skreddersydd for din bedrift\n\n📱 App-utvikling - Mobilapper og webapplikasjoner for iOS, Android og nettleser\n\n💻 IT-hjelp & Support - Feilsøking, systemoppsett, brukerstøtte og teknisk rådgivning\n\n🔍 SEO Optimalisering - Øk synlighet og organisk trafikk på Google\n\n🛠️ Vedlikehold & Drift - Oppdateringer, sikkerhet og teknisk support 24/7\n\nVil du vite mer om en spesifikk tjeneste?',
  answerTimeline: 'Vanligvis tar det 5-10 dager fra prosjektstart til lansering for nettsider, avhengig av kompleksitet og omfang.\n\nFor app-utvikling varierer tidslinjen mer basert på funksjonalitet og plattform.\n\nProsessen inkluderer:\n1. Innledende samtale\n2. Planlegging & design\n3. Utvikling\n4. Gjennomgang & tilbakemelding\n5. Kvalitetssikring\n6. Lansering & support\n\nVi kan tilpasse raskere tidslinjer ved behov. Vil du booke en konsultasjon for å diskutere ditt prosjekt?',
  answerProcess: 'Vår prosess er enkel og grei:\n\n1️⃣ Innledende Samtale - Vi blir kjent og diskuterer dine behov og visjon\n\n2️⃣ Planlegging & Design - Du mottar designforslag og teknisk plan\n\n3️⃣ Utvikling - Vi bygger løsningen med ren kode og god arkitektur\n\n4️⃣ Gjennomgang & Tilbakemelding - Du gjennomgår og gir tilbakemelding\n\n5️⃣ Kvalitetssikring - Testing på alle enheter og nettlesere\n\n6️⃣ Lansering & Support - Løsningen går live med løpende support\n\nVi holder deg oppdatert gjennom hele prosessen!',
  answerContact: 'Du kan kontakte oss på følgende måter:\n\n📧 E-post: kontakt@norwebas.no\nVi svarer innen 24 timer\n\n📞 Telefon: +47 94 12 19 09\nMan-Fre: 08:30 - 16:30\n\n📍 Lokasjon: Hamar, Norge\n\n📅 Eller book en gratis konsultasjon direkte i kalenderen vår!\n\nHva passer best for deg?',
  answerSEO: 'SEO (søkemotoroptimalisering) er inkludert i alle våre nettside-pakker!\n\n🔍 Basis: SEO optimalisering\n- Grunnleggende on-page SEO\n- Meta tags og beskrivelser\n- Mobilvennlig design\n\n🔍 Standard: Avansert SEO\n- Alt fra Basis\n- Keyword research\n- Strukturert data\n- Ytelsesoptimalisering\n\n🔍 Premium: Full SEO-pakke\n- Alt fra Standard\n- Omfattende keyword strategi\n- Månedlig SEO-rapportering\n- Kontinuerlig optimalisering\n\nVi sørger for at nettstedet ditt rangerer høyere på Google!',
  answerSupport: 'Vi tilbyr omfattende support og vedlikehold:\n\n✅ Hosting inkludert\n✅ SSL-sertifikat\n✅ Sikkerhetsoppdateringer\n✅ Backup\n✅ Teknisk support\n✅ Innholdsoppdateringer (basert på pakke)\n✅ IT-hjelp ved behov\n\nSupportnivå:\n📦 Basis: Grunnleggende support\n📦 Standard: Prioritert support\n📦 Premium: Dedikert support\n\nVi holder løsningene dine sikre, oppdaterte og i gang 24/7. Du kan kontakte oss når som helst!',
  answerBooking: 'Flott! Du kan enkelt booke en gratis konsultasjon:\n\n📅 Klikk på "Book en Konsultasjon"-knappen på nettsiden\n⏰ Velg et tidspunkt som passer deg\n💬 Vi tar en uforpliktende prat om ditt prosjekt – nettside, app eller IT-hjelp\n\nKonsultasjonen varer ca 15 minutter og kan gjøres via video eller telefon.\n\nIngen forberedelse nødvendig - vi guider deg gjennom samtalen!\n\nVil du at jeg hjelper deg med å finne bookingknappen?',
  answerDefault: 'Takk for spørsmålet! Jeg kan hjelpe deg med informasjon om:\n\n💰 Priser og pakker\n🛠️ Tjenester vi tilbyr (nettsider, apper, IT-hjelp)\n⏱️ Tidslinjer og leveranse\n📋 Vår arbeidsprosess\n📞 Kontaktinformasjon\n🔍 SEO og optimalisering\n🤝 Support og vedlikehold\n📅 Booking av konsultasjon\n\nHva vil du vite mer om?'
};

export const analyse = {
  skipToMain: 'Hopp til hovedinnhold',
  mainNav: 'Hovednavigasjon',
  logoAria: 'NorWeb AS - Gå til forsiden',
  contactBtn: 'Kontakt Oss',
  hero: {
    title: 'Se hva som koster deg kunder',
    subtitle: 'Få en gratis og umiddelbar analyse av nettsiden din – på få sekunder.',
    inputLabel: 'Skriv inn ditt domene',
    placeholder: 'Skriv inn ditt domene (f.eks. dittfirma.no)',
    ctaButton: 'Analyser nettsiden min',
    analyzing: 'Analyserer...',
    privacy: 'Ingen pålogging kreves. Helt gratis og uforpliktende.',
    feature1Title: 'Øyeblikkelig Analyse',
    feature1Desc: 'Få resultater på få sekunder',
    feature2Title: '100% Gratis',
    feature2Desc: 'Ingen skjulte kostnader',
    feature3Title: 'Profesjonell Rapport',
    feature3Desc: 'Detaljert innsikt og anbefalinger'
  },
  results: {
    title: 'Analyseresultater',
    downloadPDF: 'Last ned PDF',
    verifiedBadge: 'Verifisert nettside',
    modernStandardsBadge: 'Utviklet med moderne standarder',
    // Standard domain score labels
    scoreExcellent: 'Sterk ytelse',
    scoreGood: 'Moderat forbedringspotensial',
    scoreFair: 'Forbedringspotensial',
    scorePoor: 'Trenger betydelig forbedring',
    // Preferred domain score labels
    scoreExcellentPreferred: 'Sterk ytelse',
    scoreGoodPreferred: 'Solid ytelse',
    scoreFairPreferred: 'Forbedringspotensial',
    // Standard domain summaries
    summaryExcellent: 'Nettsiden din presterer godt! Det er fortsatt rom for små forbedringer som kan øke konverteringer ytterligere.',
    summaryGood: 'Nettsiden din har et solid grunnlag, men det er flere områder som kan forbedres for å øke synlighet og konverteringer.',
    summaryPoor: 'Nettsiden din har betydelig forbedringspotensial. Flere tekniske og strategiske faktorer påvirker både synlighet og konverteringer negativt.',
    // Preferred domain summaries
    summaryExcellentPreferred: 'Nettsiden din har et solid fundament med utmerket ytelse. Små optimaliseringer kan gi ytterligere forbedringer.',
    summaryGoodPreferred: 'Nettsiden din har et solid fundament med enkelte optimaliseringsmuligheter.',
    summaryFairPreferred: 'Nettsiden din har et godt grunnlag med noen områder som kan optimaliseres for enda bedre resultater.',
    metrics: {
      pageSpeed: 'Hastighet',
      mobileResponsive: 'Mobilvennlig',
      seo: 'SEO',
      security: 'Sikkerhet',
      accessibility: 'Tilgjengelighet',
      design: 'Design',
      cta: 'CTA Synlighet',
      trustSignals: 'Tillitssignaler'
    },
    // Standard domain issue title
    issuesTitle: 'Kritiske Forbedringsområder',
    // Preferred domain issue title
    issuesTitlePreferred: 'Optimaliseringsmuligheter',
    impact: 'Påvirkning på virksomheten',
    whyItMatters: 'Hvorfor dette er viktig',
    ctaTitle: 'Klar til å forbedre nettsiden din?',
    ctaDescription: 'La oss hjelpe deg med å løse disse problemene og skape en nettside som konverterer besøkende til kunder.',
    ctaPrimary: 'Book en Gratis Strategisamtale',
    ctaSecondary: 'Se Våre Tjenester'
  },
  revenue: {
    title: 'Estimert Inntektspotensial',
    titlePreferred: 'Optimaliseringspotensial',
    subtitle: 'Små forbedringer kan gi store resultater for din bedrift',
    subtitlePreferred: 'Finjusteringer kan gi ytterligere forbedringer',
    conversionIncrease: 'Økning i konverteringsrate',
    conversionIncreasePreferred: 'Potensiell konverteringsøkning',
    conversionDesc: 'Kan bety betydelig økt omsetning',
    conversionDescPreferred: 'Med ytterligere optimalisering',
    trafficIncrease: 'Mer organisk trafikk',
    trafficDesc: 'Med bedre SEO og ytelse',
    trafficDescPreferred: 'Med finjustert SEO',
    revenueIncrease: 'Økt inntekt',
    revenueDesc: 'Gjennom optimalisering',
    revenueDescPreferred: 'Gjennom finjustering',
    example: 'Hvis nettsiden din har 1 000 besøkende per måned og vi øker konverteringsraten med bare 1%, kan det bety betydelig økt omsetning. Med bedre SEO kan vi doble trafikken din, og med optimalisert design og struktur kan vi øke konverteringene med opptil 40%. Dette er ikke bare tall – det er reell vekst for din bedrift.',
    examplePreferred: 'Nettsiden din har allerede et godt fundament. Med målrettede optimaliseringer kan vi finjustere ytelsen ytterligere. Selv små forbedringer på 0,5-1,5% i konverteringsrate kan gi merkbar vekst over tid.'
  },
  whyHappens: {
    title: 'Hvorfor Skjer Dette?',
    titlePreferred: 'Områder for Optimalisering',
    reason1Title: 'Ingen konverteringsstrategi',
    reason1Desc: 'Nettsiden er ikke bygget med konvertering som hovedmål. Design og struktur mangler strategisk fokus på å gjøre besøkende til kunder.',
    reason2Title: 'Manglende UX-optimalisering',
    reason2Desc: 'Brukeropplevelsen er ikke optimalisert. Besøkende finner ikke det de leter etter raskt nok, eller prosessen er for komplisert.',
    reason3Title: 'Ingen teknisk ytelsesoptimalisering',
    reason3Desc: 'Treg lasting, dårlig mobilopplevelse og tekniske problemer får besøkende til å forlate siden før de konverterer.',
    reason4Title: 'Svakt SEO-grunnlag',
    reason4Desc: 'Nettsiden rangerer ikke høyt nok på Google. Potensielle kunder finner konkurrentene dine i stedet for deg.',
    reason5Title: 'Ikke tilpasset moderne kjøpsatferd',
    reason5Desc: 'Dagens kunder forventer rask informasjon, tydelige handlingsoppfordringer og en sømløs opplevelse på alle enheter.'
  },
  whyChooseUs: {
    title: 'Hvorfor Velge Oss?',
    subtitle: 'Vi bygger ikke bare nettsider – vi bygger digitale salgsverktøy som leverer resultater',
    benefit1Title: 'Konverteringsfokuserte Nettsider',
    benefit1Desc: 'Vi designer og bygger med ett mål: å gjøre besøkende til betalende kunder.',
    benefit2Title: 'Hastighet & SEO-Optimalisering',
    benefit2Desc: 'Raske lastetider og topp SEO-praksis sikrer at du rangerer høyt og beholder besøkende.',
    benefit3Title: 'Mobil-Først Design',
    benefit3Desc: 'Over 60% av trafikken kommer fra mobil. Vi sikrer perfekt opplevelse på alle enheter.',
    benefit4Title: 'Tydelig Konverteringsstruktur',
    benefit4Desc: 'Strategisk plasserte CTA-er, tillitssignaler og brukerreiser som leder til handling.',
    benefit5Title: 'Målbar ROI',
    benefit5Desc: 'Vi fokuserer på resultater du kan måle: mer trafikk, flere leads, økt omsetning.',
    benefit6Title: 'Løpende Support & Optimalisering',
    benefit6Desc: 'Vi er med deg hele veien – fra lansering til kontinuerlig forbedring og vekst.',
    ctaPrimary: 'Book en Gratis Strategisamtale',
    ctaSecondary: 'Få et Skreddersydd Tilbud'
  },
  error: {
    failed: 'Kunne ikke analysere nettsiden. Vennligst sjekk domenet og prøv igjen.'
  }
};

export const analyseSection = {
  title: 'Gratis Nettside-Analyse',
  subtitle: 'Finn ut hva som holder nettsiden din tilbake',
  description: 'Vår gratis analyse gir deg innsikt i hvordan nettsiden din presterer på viktige områder som hastighet, SEO, mobilvennlighet og sikkerhet. På få sekunder får du en detaljert rapport med konkrete forbedringsforslag som viser hvordan vi kan gjøre nettsiden din bedre.',
  feature1: 'Øyeblikkelig resultat',
  feature2: 'Ingen forpliktelser',
  feature3: 'Detaljert rapport',
  btn: 'Analyser nå'
};
